import React, { useEffect, useState } from "react";
import Heading from "../Heading";
import SkillItem from "./SkillItem";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const getItems = [
  "kafka",
  "spring",
  "hibernate",
  "mysql",
  "java",
  "html",
  "css",
  "maven",
  "git",
  "boot",
  "react",
  "js",
  "flutter",
  "docker",
];

function Skills() {
  const [items, setItems] = useState(getItems);

  const [slidesToShow, setSlidesToShow] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1000) {
        setSlidesToShow(3);
      } else {
        setSlidesToShow(4);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value based on current window size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: slidesToShow,
    slidesToScroll: 4,
    mobileFirst: true,
  };

  return (
    <div id="skills" className="mx-3 md:mx-20 mb-10 ">
      <Heading text={"Skills"} />
      <Slider {...settings} arrows={false} >
        {items.map((el, id) => (
          <SkillItem key={id} name={el} />
        ))}
      </Slider>
    </div>
  );
}

export default Skills;
